<script>
    export default {
        name: "NegotiationsItem",
        props: {
            item: {
                type: Object,
                default: () => {}
            }
        },
        data () {
            return {
                totalPrice: '',
                expiresIn: ''
            }
        },
        computed: {
            userType () {
                return this.$store.getters['user/userType'];
            },
            hasImage () {
                // TODO
                return this.item.cover_image_url;
            }
        },
        async mounted () {
            if (this.item.offer_expires_at) {
                this.expiresIn = this.calculateExpiration();
            }
        },
        methods: {
           calculateExpiration () {
                const date1 = new Date(this.item.offer_expires_at);
                const date2 = new Date();
                const diffTime = Math.abs(date2 - date1);
                return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            },
            openModal () {
               this.$emit('click', this.item._id);
            },
            capitaliseString (string) {
                return (string.charAt(0).toUpperCase() + string.slice(1)).replace(/_/g, " ");
            }
        }
    }
</script>

<template>
    <div @click="openModal" class="card agreement-box tab-section p-0">
<!--        <div v-if="hasImage" class="card-top-image-container" :style="{ backgroundImage: `url('${item.cover_image_url}')` }"></div>-->
        <div class="card-body body-padding">
            <div class="d-flex align-items-center justify-content-between mb-2">
                <h5 class="mb-0 text-dark">{{ capitaliseString(item.campaign_name) }}</h5>
                <div class="social-image-container">
                    <img v-if="item.social_network === 'instagram'"
                         :src="require('@/assets/images/brands/instagram.png')" class="img-fluid" alt="">
                    <img v-if="item.social_network === 'facebook'"
                         :src="require('@/assets/images/brands/facebook.png')" class="img-fluid" alt="">
                    <img v-if="item.social_network === 'youtube'"
                         :src="require('@/assets/images/brands/youtube.png')" class="img-fluid" alt="">
                    <img v-if="item.social_network === 'blog'"
                         :src="require('@/assets/images/brands/analytics-logo.png')" class="img-fluid" alt="">
                </div>
            </div>
            <div class="text-muted row">
                <div class="col-auto">
                    <i class="far fa-calendar-alt"></i>
                    {{ new Date(item.campaign_date).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) }}
                </div>
                <div class="col word-wrap text-right">
                    {{ capitaliseString(item.post_type) }}
                    <i v-if="item.giveaway" class="bx bxs-gift font-size-18 align-middle" v-b-tooltip.hover.bottom title="Giveaway"></i>
                    <i v-if="item.event" class="bx bxs-calendar-event font-size-18 align-middle" v-b-tooltip.hover.bottom title="Event"></i>
                </div>
            </div>
            <div v-if="hasImage" class="thumbnail">
                <img :src="item.cover_image_url" alt="" class="img-fluid thumbnail-image">
            </div>
            <div class="row" :class="[ hasImage ? 'mt-2' : 'mt-4' ]">
                <div class="col d-flex align-items-center">
                    <div v-if="item.notifications" class="notification d-flex align-items-center justify-content-center badge badge-danger mr-1 mr-xl-2 px-1">
                        <i  class="bx bx-bell" style="font-size: 16px;"></i>
                        <span class="notification-number mx-1">{{ item.notifications.length }}</span>
                    </div>
                    <div v-if="item.comments_count" class="notification d-flex align-items-center justify-content-center badge text-muted mr-1 mr-xl-2">
                        <i  class="bx bx-comment" style="font-size: 16px;"></i>
                        <span class="notification-number mx-1">{{ item.comments_count }}</span>
                    </div>
                    <div v-if="item.attachments_count" class="notification d-flex align-items-center justify-content-center badge text-muted mr-1 mr-xl-2">
                        <i class="fas fa-paperclip" style="font-size: 14px;"></i>
                        <span class="notification-number mx-1">{{ item.attachments_count }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row m-0 justify-content-end">
                <div class="col p-0 d-flex align-items-center">
                    <img v-if="item.picture_url" :src="item.picture_url" class="rounded-circle avatar-xs" alt />
                    <div v-else-if="item.picture_alt" class="media-object avatar-xs letter-in-circle">{{ item.picture_alt.charAt(0) }}</div>
                    <div class="d-flex align-items-center justify-content-center badge">
                        <span class="notification-number mx-1">{{ item.picture_alt }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .social-image-container {
        height: 20px;
        width: 24px;
    }
    .thumbnail {
        margin-top: 10px;
        max-height: 140px;
        display:flex;
        justify-content: center;
        background-color: #e0ebf5;
    }
    .thumbnail-image {
        max-height: 140px;
    }
</style>
